<section id="section-report" class="container-fluid mt-1">
  <div class="row" *ngIf="remissionModel">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{ remissionModel.remissionId }}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{ remissionModel.remissionId }}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()" />

                  <!--Nit -->
                  <label id="t-nit-empresa-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-nit-empresa" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="nit-empresa-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.enterpriseNit }}
                  </p>

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.enterpriseName }}
                  </p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.branchName }}
                  </p>

                  <!--Nombre Remisión -->
                  <p id="nombre-remision-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ 'REMISIÓN Nro.'+ remissionModel.consecutive }}
                  </p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-direccion" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="direccion-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.address }}
                  </p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{ "t-telefono" | formatLabelPipe : elementsLabel }}
                  </label>
                  <p id="telefono-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.phone }}
                  </p>

                  <!-- Fecha Remisión -->
                  <label id="t-fecha-remision-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-fecha-remision" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="fecha-remision-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.dateRemission | date : "dd/MM/yyyy" }}
                  </p>

                  <!--C.Costos  -->
                  <label id="t-centro-costos-{{ remissionModel.remissionId }}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{ "t-centro-costos" | formatLabelPipe : elementsLabel }}</label>
                  <p id="centro-costos-{{ remissionModel.remissionId }}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{ remissionModel.costCenterCodeName }}
                  </p>

                  <!-- Fecha Factura -->
                  <label id="t-fecha-factura-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-fecha-factura" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="fecha-factura-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.dateInvoice | date : "dd/MM/yyyy" }}
                  </p>

                  <!-- Dirección -->
                  <label id="t-direccion-obra-{{ remissionModel.remissionId }}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-direccion-obra" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="direccion-obra-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.constructionSiteAddress }}
                  </p>

                  <!--Teléfono  -->
                  <label id="t-telefono-obra-{{ remissionModel.remissionId }}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-telefono-obra" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="telefono-obra-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.constructionSitePhone }}
                  </p>

                  <!--Teléfono Alterno  -->
                  <label id="t-telefono-obra-alt-{{ remissionModel.remissionId }}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                    "t-telefono-obra-alt" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="telefono-obra-alt-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.constructionSiteAlterPhone }}
                  </p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{ remissionModel.remissionId }}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{ "t-cliente" | formatLabelPipe : elementsLabel }}</label>
                  <p id="cliente-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.clientDocumentName }}
                  </p>

                  <!--Hora Llegada  -->
                  <label id="t-hora-llegada-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-hora-llegada" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="linea-hora-llegada-{{ remissionModel.remissionId }}" class="write-line" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!--Hora Entrega  -->
                  <label id="t-hora-entrega-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-hora-entrega" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="linea-hora-entrega-{{ remissionModel.remissionId }}" class="write-line" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!--Departamento destino  -->
                  <label id="t-departamento-destino-{{ remissionModel.remissionId }}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{
                    "t-departamento-destino" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="departamento-destino-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{remissionModel.destinityDepartment }}
                  </p>

                  <!--Ciudad destino  -->
                  <label id="t-ciudad-destino-{{ remissionModel.remissionId }}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-ciudad-destino" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="ciudad-destino-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{remissionModel.destinityCity }}
                  </p>

                  <!--Comodin 1  -->
                  <label id="t-comodin-1-{{ remissionModel.remissionId }}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-comodin-1" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="comodin-1-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.wildcard }}
                  </p>

                  <!-- Comodin 2 -->
                  <label id="t-comodin-2-{{ remissionModel.remissionId }}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{
                    "t-comodin-2" | formatLabelPipe : elementsLabel
                    }}</label>
                  <p id="comodin-2-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{ remissionModel.wildcard2 }}
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-remision-{{ remissionModel.remissionId }}" [columns]="columns"
                  [data]="remissionModel.remissionDetails" [idMap]="idMap" [documentId]="remissionModel.remissionId"
                  [footerVisible]="true" [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{ remissionModel.remissionId }}" class="foot mt-1 container-observations">
                <label id="t-observación-remision-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()" *ngIf="remissionModel.printObservation">{{
                  "t-observación-remision" | formatLabelPipe : elementsLabel
                  }}</label>
                <p id="observación-remision-{{ remissionModel.remissionId }}" class="lh-sm observation-remision"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()" *ngIf="remissionModel.printObservation">
                  {{ remissionModel.printObservation }}
                </p>

                <!-- Observaciones Sucursal -->
                <p id="observacion-sucursal-{{ remissionModel.remissionId }}" class="lh-sm observation-remision"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{ remissionModel.remissionObservation }}
                </p>

                <!-- Transporte -->
                <label id="t-valor-transporte-{{ remissionModel.remissionId }}" for="" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{
                  "t-valor-transporte" | formatLabelPipe : elementsLabel }}</label>
                <p id="valor-transporte-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  {{ remissionModel.transportValue | currency }}
                </p>

                <!-- Transportador-->
                <p id="transportador-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  {{ remissionModel.transporterName }}
                </p>
                <p id="linea-firma-transportador-{{remissionModel.remissionId}}" class="write-line" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                </p>
                <label id="t-firma-transportador-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{ "t-firma-transportador" | formatLabelPipe : elementsLabel }}</label>

                <!-- Firma Entrega-->
                <p id="linea-firma-entrega-{{ remissionModel.remissionId }}" class="write-line" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-entrega-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{
                  "t-linea-entrega" | formatLabelPipe : elementsLabel
                  }}</label>

                <!-- Firma Recibe-->
                <p id="linea-firma-recibe-{{ remissionModel.remissionId }}" class="write-line" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-recibe-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{
                  "t-linea-recibe" | formatLabelPipe : elementsLabel
                  }}</label>

                <!-- Firma Responsable-->
                <p id="linea-firma-responsable-{{ remissionModel.remissionId }}" class="write-line" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-responsable-{{ remissionModel.remissionId }}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                  {{ "t-linea-responsable" | formatLabelPipe : elementsLabel }}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4">{{ version }}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha:
                </label>
                <p id="fecha-impresion" class="pe-4">
                  {{ dateNow | date : "dd/MM/yyyy" }}
                </p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4">
                  {{ dateNow | date : "hh:mm:ss a" }}
                </p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario:
                </label>
                <p id="usuario-impresion" class="pe-4">
                  {{ userAuthenticated }}
                </p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">
                    Documento generado con el Software Cervino Web de Altos
                    Software SAS. Nit.811.022.121-1. www.altos-soft.com
                  </p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>